import React, { Component } from 'react'
import { withStyles, Button } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete'

const styles = theme => ({
    root: {
        width: '100%',
        overflowX: 'scroll'
    }
})

class FullPapers extends Component {
    state = {
        title: '',
        details: '',
        issn: '',
      
        no_co_au:'',
        main_au:'',
        institution:'',
        api_score:'',
        year:'',
        full_papers: []
    }

    componentDidMount(){
        //console.log(this.props)
        this.setState({
            full_papers:this.props.full_papers,
        })
    }

    componentDidUpdate(prevProps){
        if(this.props !== prevProps){
            this.setState({
                full_papers:this.props.full_papers,

            })
        }
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onSubmit = () => {
        let d = {
            title: this.state.title,
            details: this.state.details,
            issn: this.state.issn,
            no_co_au: this.state.no_co_au,
            main_au: this.state.main_au,
            institution: this.state.institution,
            api_score: this.state.api_score,
            year: this.state.year,
            
        }

        let full_papers = this.state.full_papers;
        full_papers.push(d);
        this.setState({
            full_papers
        }, () => {
                this.props.setFullPapers(full_papers);
                this.setState({
                    title: '',
                    details: '',
                    issn: '',
                    no_co_au:'',
                    main_au:'',
                    institution:'',

                    api_score:'',
                    year:'',
                })
        })
    }

    onDelete = (index) => {
        let full_papers = this.state.full_papers;
        full_papers.splice(index,1);
        this.props.setFullPapers(full_papers);
        this.setState({
            full_papers
        })
    }
    render() {
        let { classes } = this.props;
        return (
            <div className={classes.root}>
                <table width="100%" className="table">

                    <thead>
                        <tr>
                            <td width="20%">Title with Page Numbers</td>
                            <td width="40%">Title, editor & publisher and Year</td>
                           
                            <td>ISSN/ ISBN No.</td>
                           
                            <td>No. of 
                                    Co-author</td>
                                    <td>Whether you are the main author</td>
                                    <td>Whether at the time of publication Affiliating Institution was same
Yes/ No</td>
                                    <td>API Score</td>
                                    <td>Year</td>
                            <td>Click + to Add</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td width="20%">
                                <textarea
                                    className="form-control"
                                    type="text"
                                    name="title"
                                    value={this.state.title}
                                    onChange={this.onChange}
                                    placeholder="Title with Page Numbers"
                                />
                            </td>
                            <td width="40%">
                                <textarea
                                    className="form-control"
                                    type="text"
                                    name="details"
                                    value={this.state.details}
                                    onChange={this.onChange}
                                    placeholder="Title, editor & publisher and Year"
                                />
                            </td>
                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="issn"
                                    value={this.state.issn}
                                    onChange={this.onChange}
                                    placeholder="ISSN/ ISBN No"
                                />
                            </td>

                           

                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="no_co_au"
                                    value={this.state.no_co_au}
                                    onChange={this.onChange}
                                    placeholder="No. of 
                                    Co-author"
                                />
                            </td>

                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="main_au"
                                    value={this.state.main_au}
                                    onChange={this.onChange}
                                    placeholder="Whether you are the main author"
                                />
                            </td>

                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="institution"
                                    value={this.state.institution}
                                    onChange={this.onChange}
                                    placeholder="Yes/No"
                                />
                            </td>

                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="api_score"
                                    value={this.state.api_score}
                                    onChange={this.onChange}
                                    placeholder="API Score"
                                />
                            </td>
                            
                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="year"
                                    value={this.state.year}
                                    onChange={this.onChange}
                                    placeholder="Year"
                                />
                            </td>
                            <td>

                                <Button
                                    variant="outlined"
                                    onClick={this.onSubmit}
                                    type="button"
                                >
                                    +
                                </Button>

                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        {this.state.full_papers.map((el, index) =>

                            <tr key={index}>
                                <td>{index+1}. {el.title}</td>
                                <td>{el.details}</td>
                                <td>{el.issn}</td>
                                <td>{el.no_co_au}</td>
                                <td>{el.main_au}</td>
                                <td>{el.institution}</td>
                                <td>{el.api_score}</td>
                                <td>{el.year}</td>
                                
                                <td><Delete onClick={this.onDelete.bind(this,index)} /></td>
                            </tr>

                        )}
                       
                    </tbody>

                </table>
            </div>
        )
    }
}

export default withStyles(styles)(FullPapers)